(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/behaviors/header.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/behaviors/header.js');
"use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.syndicate.core.behaviors.Header = Marionette.Behavior.extend({
    options: {
      showMyTeamsButton: false
    },
    initialize() {
      this.updateHeader();
    },
    updateHeader() {
      const templateConfig = {
        title: {
          row1: {
            text: 'Spela tillsammans'
          }
        }
      };
      svs.core.template.updateConfig(templateConfig);
    },
    displayGameGuide() {
      const view = svs.tur.views.gameguide.Spelguide;
      let articles;
      const showGameGuide = function () {
        if (articles && articles.length) {
          svs.components.Modal.show(view, {
            collection: articles
          }, {
            title: 'Spelguide',
            headerClass: 'header-tur',
            doubleWidth: !svs.core.detect.formfactor.mobile(),
            leftButton: {
              visible: false
            },
            rightButton: {
              text: 'Stäng',
              visible: true,
              cssClass: 'btn btn-100 modal-button-right btn-transparent-default'
            }
          });
        } else {
          const errorMessage = "Av n\xE5gon anledning kan spelguiden inte visas f\xF6r tillf\xE4llet. " + "V\xE4nligen f\xF6rs\xF6k igen eller kontakta kundservice. " + "F\xF6r fullst\xE4ndiga spelregler <a href=".concat(svs.core.urlMapping.get('terms'), ">klicka h\xE4r.</a>");
          const dialog = new svs.ui.dialog.Confirm({
            branding: svs.ui.dialog.branding.TUR,
            type: svs.ui.dialog.type.ERROR,
            title: 'Spelguiden kan inte visas',
            message: [{
              type: svs.ui.dialog.message.TEXT,
              text: errorMessage
            }],
            actions: [{
              title: 'Okej'
            }]
          });
          svs.ui.dialog.api.add(dialog);
        }
      };
      if (!articles) {
        if (svs.arena.data.config.gameGuide && svs.arena.data.config.gameGuide.guides && svs.arena.data.config.gameGuide.guides.length) {
          articles = new svs.tur.gameguide.Spelguider({
            product: 'playtogether',
            guides: svs.arena.data.config.gameGuide.guides
          });
        } else {
          showGameGuide();
        }
        articles.listenToOnce(articles, 'sync', () => {
          showGameGuide();
        });
      } else {
        showGameGuide();
      }
    },
    navigateToMyTeams() {
      Backbone.history.navigate(svs.core.urlMapping.get('playTogetherTeams').split('/').pop(), {
        trigger: true
      });
    }
  });
})(Backbone, _, svs);

 })(window);